import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBrandUrl } from "@/hooks";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useContactContext } from "@/contexts/contact";
export const imageFallbackTestId = "cdp-image-fallback";
export const ImageFallback = ({ variant, title, description, icon, }) => {
    if (variant === "preview") {
        return (_jsx(PreviewVariant, { testId: `${imageFallbackTestId}-${variant}`, title: title, description: description, icon: icon }));
    }
    return (_jsx(FullScreenVariant, { testId: `${imageFallbackTestId}-${variant}`, title: title, description: description, icon: icon }));
};
const PreviewVariant = ({ testId, title, description, icon }) => {
    const fallbackImageUrl = useBrandUrl({
        endpoint: "/shared/images/media/gallery-fallback.png",
    });
    return (_jsxs(Box, { as: "picture", position: "relative", width: "100%", testId: testId, children: [_jsx(Box, { as: "img", src: fallbackImageUrl, alt: "fallback-image", height: "100%", width: "100%", objectFit: "cover", objectPosition: "100% 50%", id: "currentImage" }), _jsx(Box, { position: "absolute", width: "100%", height: "100%", top: 0, left: 0, display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(FallbackText, { colorScheme: "default", title: title, description: description, icon: icon }) })] }));
};
const FullScreenVariant = ({ testId, title, description, icon, }) => {
    return (_jsx(Box, { width: "100%", height: "100%", color: "color.content.constant.white", display: "flex", justifyContent: "center", alignItems: "center", testId: testId, children: _jsx(FallbackText, { colorScheme: "inverted", title: title, description: description, icon: icon }) }));
};
const FallbackText = ({ colorScheme, title, description, icon, }) => {
    const { toggleModal } = useContactContext();
    const Icon = icon;
    const { t } = useI18n();
    const handlePress = () => {
        toggleModal({
            av_zone: "image_preview_noimages",
            legacyTrackingInfos: "image_preview_noimages",
        }); //tracking TBD
    };
    return (_jsxs(Box, { display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", color: colorScheme === "default" ? "inherit" : "color.content.constant.white", paddingHorizontal: "spacing.16", paddingTop: "spacing.16", paddingBottom: "spacing.32", children: [_jsx(Box // FIXME This box is temporary and should be remove when designers will fix the new layout. The icon in ImageFallback is out of its container on breakpoint.lg thats why we temporary hide it
            , { display: {
                    "breakpoint.base": "block",
                    "breakpoint.lg": "none",
                    "breakpoint.xl": "block",
                }, children: _jsx(Icon, { color: colorScheme === "default"
                        ? "inherit"
                        : "color.content.constant.white", size: "sizing.24", marginBottom: "spacing.16" }) }), _jsx(Box, { as: "span", typography: {
                    "breakpoint.base": "typography.body.14.bold",
                    "breakpoint.lg": "typography.body.12.bold",
                    "breakpoint.xxl": "typography.body.14.bold",
                    "breakpoint.xxxl": "typography.body.16.bold",
                }, marginBottom: {
                    "breakpoint.base": "spacing.4",
                    "breakpoint.xxl": "spacing.8",
                }, children: title }), _jsx(Box, { typography: {
                    "breakpoint.base": "typography.body.14.regular",
                    "breakpoint.lg": "typography.body.12.regular",
                    "breakpoint.xxl": "typography.body.14.regular",
                    "breakpoint.xxxl": "typography.body.16.regular",
                }, whiteSpace: "pre-line", maxWidth: "100%", display: {
                    "breakpoint.base": "none",
                    "breakpoint.lg": "flex",
                }, children: description }), _jsx(Box, { display: {
                    "breakpoint.base": "flex",
                    "breakpoint.lg": "none",
                }, marginTop: "spacing.12", width: "100%", children: _jsx(Button, { variant: "secondary-floating", onPress: handlePress, size: "32", children: t("contact.gallery.email") }) })] }));
};
